import { Injectable } from '@angular/core';
import { config } from '@tag/graphql';
import type { GraphQLParams, PostedTimesheet } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';

export interface Response {
  postedTimesheets: { items: PostedTimesheet[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class PostedTimesheetsGQL extends Query<
  Response,
  GraphQLParams<'postedTimesheet'>
> {
  document = gql(config.postedTimesheet.query);
}
